// src/client/usePathnameWithoutSplatRouteParams.tsx
import { useLocation, useParams } from "react-router";
var usePathnameWithoutSplatRouteParams = () => {
  const params = useParams();
  const { pathname } = useLocation();
  const splatRouteParam = params["*"] || "";
  const path = pathname.replace(splatRouteParam, "").replace(/\/$/, "").replace(/^\//, "").trim();
  return `/${path}`;
};
export {
  usePathnameWithoutSplatRouteParams
};
//# sourceMappingURL=usePathnameWithoutSplatRouteParams.js.map